import AbstractBotaoTabela from './AbstractBotaoTabela';

export default class Exportar extends AbstractBotaoTabela {
    constructor(tableId, title = 'Relatório', filename = null, topMessage = '') {
        super(tableId);

        this.title = title;
        this.filename = filename || title;
        this.topMessage = topMessage;
    }

    getCallback() {
        const tableId = this.tableId;
        const buttonDefault = {
            title: this.title,
            messageTop: this.topMessage,
            filename: this.filename,
            action: $.fn.dataTable.exportarTodasPaginas,
            exportOptions: {
                orthogonal: 'export',
                columns: function(idx, data, node) {
                    const table = $('#' + tableId).DataTable();
                    const col = table.column(idx);
                    return node.classList.contains('not-export-col') ? false : col.visible();
                },
            },
        };

        return {
            extend: 'collection',
            align: 'container',
            text: this.getText(),
            buttons: [
                {
                    ...buttonDefault,
                    extend: 'copyHtml5',
                },
                {
                    ...buttonDefault,
                    extend: 'excelHtml5',
                    customize: $.fn.dataTable.customizeExcel,
                },
                {
                    ...buttonDefault,
                    extend: 'csvHtml5',
                    charset: 'Windows-1252',
                    bom: true,
                }, {
                    ...buttonDefault,
                    extend: 'pdfHtml5',
                    orientation: 'landscape',
                },
            ],
        };
    }

    getIcone() {
        return 'file_download';
    }

    getLabel() {
        return 'Exportar';
    }
}